import { STR_ADJUSTMENTS } from "../constants/abilityAdjustments";

export function calculateStrengthBonus(character) {
  let strengthLookupKey = character.stats['myStr'].toString().replace(/[^0-9/]/g, '');
  if (character.stats['myStr'].toString().includes('18/')) {
    console.log('exceptional strength ', character.stats['myStr']);
    let strPercentage = parseInt(character.stats['myStr'].slice(-2));
    if (strPercentage < 100) { strengthLookupKey = '18/91'; }
    if (strPercentage < 91) { strengthLookupKey = '18/76'; }
    if (strPercentage < 76) { strengthLookupKey = '18/51'; }
    if (strPercentage < 51) { strengthLookupKey = '18/01'; }
    if (strPercentage === 0) { strengthLookupKey = '18/00'; }
    console.log(strPercentage);
  }

  let STR_bonus_string = "";
  try {
      const STR_adj = STR_ADJUSTMENTS[strengthLookupKey];
      console.log('STR Adj: ', character.stats['myStr'], STR_adj);

      let adjuster = STR_adj['toHit'];
      const th_bonus = adjuster === 0 ? "" :
        (adjuster < 0 ? `-${Math.abs(adjuster)}` : `+${adjuster}`);
      console.log('To Hit: ', th_bonus);

      adjuster = STR_adj['damage'];
      const dmg_bonus = adjuster === 0 ? "" :
        (adjuster < 0 ? `-${Math.abs(adjuster)}` : `+${adjuster}`);
      console.log('Damage: ', dmg_bonus);

      
      if (th_bonus === "" && dmg_bonus !== "") {
        STR_bonus_string = '0/' + dmg_bonus;
      } else if (th_bonus !== "" && dmg_bonus !== "") {
        STR_bonus_string = th_bonus + "/" + dmg_bonus;
      }

      return { str: STR_bonus_string, dict: STR_adj };

  } catch(error) {
    console.log('fail gracefully')
    console.log(error)
  }

  return { str: STR_bonus_string };
}